import apiClient from './client';
import type { DesktopAnalyticsData } from '../types/desktopAnalytics';

export async function getDesktopAnalytics(days = 30): Promise<DesktopAnalyticsData> {
  const { data } = await apiClient.get<DesktopAnalyticsData>('/admin/desktop/analytics/', {
    params: { days },
  });
  return data;
}
